[
  {
    "id": "c1",
    "organizationId": "org-123",
    "text": "Erstbewertung abgeschlossen. Alle Dokumente sehen gut aus.",
    "date": "2024-11-15T10:30:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c2",
    "organizationId": "org-123",
    "text": "Warte auf zusätzliche Überprüfung durch die Rechtsabteilung.",
    "date": "2024-11-20T14:15:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c3",
    "organizationId": "org-123",
    "text": "Die Organisation erfüllt alle Anforderungen und wurde nach sorgfältiger Prüfung genehmigt.",
    "date": "2024-11-25T09:00:00Z",
    "author": "Admin User",
    "type": "APPROVAL"
  },
  {
    "id": "c4",
    "organizationId": "org-456",
    "text": "Dokumente eingegangen. Überprüfung läuft.",
    "date": "2024-11-18T11:00:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c5",
    "organizationId": "org-789",
    "text": "Fehlende Unterlagen angefordert.",
    "date": "2024-11-22T13:45:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c5b",
    "organizationId": "org-789",
    "text": "Die eingereichten Dokumente erfüllen nicht die erforderlichen Standards. Antrag wurde abgelehnt.",
    "date": "2024-11-28T16:30:00Z",
    "author": "Admin User",
    "type": "REJECTION"
  },
  {
    "id": "c6",
    "organizationId": "org-234",
    "text": "Bewerbung eingegangen und wird derzeit bewertet.",
    "date": "2024-11-21T10:00:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c7",
    "organizationId": "org-567",
    "text": "Hochwertige Unterlagen eingereicht. Alle Anforderungen erfüllt.",
    "date": "2024-11-19T09:15:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c8",
    "organizationId": "org-567",
    "text": "BioMed Research erfüllt alle Kriterien für die Zulassung. Genehmigung erteilt.",
    "date": "2024-11-26T15:30:00Z",
    "author": "Admin User",
    "type": "APPROVAL"
  }
]
